import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import DropdownMenu from "../B2BMainNav/DropdownMenu.esm.js";
import { FONT_FAMILY_UI } from "../_constellationUiTokens.esm.js";
const SUBNAV_DROPDOWN_Z_INDEX = 100011;
const subnavDropdownRow = css({
  paddingBlock: "tighter",
  paddingInline: "default",
  fontFamily: FONT_FAMILY_UI,
  fontSize: "body-sm",
  lineHeight: "body-sm",
  listStyle: "none",
  _hover: {
    backgroundColor: "blue.100"
  },
  _focusWithin: {
    backgroundColor: "blue.100"
  }
});
const SubnavDropdown = ({
  isOpen,
  renderLink,
  children
}) => {
  return /* @__PURE__ */ jsx(DropdownMenu, { isOpen, zIndex: SUBNAV_DROPDOWN_Z_INDEX, left: 0, children: children.map((item) => /* @__PURE__ */ jsx("li", { className: subnavDropdownRow, children: renderLink(item) }, item.id)) });
};
export {
  SubnavDropdown as default
};
